import { createStyles } from "@mui/styles";
import { APTheme } from '../../../../core/TenantProvider/tenants';

const FONT_ICON_STYLES = {
	fontSize: '4rem',
	marginBottom: '-1rem',
	marginLeft: '-1rem',
	marginTop: '-1rem',
	marginRight: '-0.5rem'
};

export default (theme: APTheme) => createStyles({

	viewSelector: {

	},
	viewSelectorRadio: {
		flexDirection: 'row'
	},
	dropDownMenu: {
		position: 'absolute',
		top: -55,
		right: 0
	},

	iconDown: {
		...FONT_ICON_STYLES,
		color: '#FF5F5F'
	},
	iconUp: {
		...FONT_ICON_STYLES,
		color: '#9BE169'
	},
	iconNoChange: {
		color: '#a4a4a4',
		fontSize: '2rem',
		marginRight: 5,
	},

	miniStatSummary: {
		whiteSpace: 'normal'
	},
	miniStatLabel: {
		fontSize: '1.1rem',
		marginLeft: '0.5rem',
		//whiteSpace: 'nowrap'
	},
	miniStatLabelText: {
		fontSize: '1.1rem'
	},
	miniStatValue: {
		whiteSpace: 'nowrap'
	},

	headlines: {
		display: 'flex',
		margin: '15px 0 10px 0',
		'@media(max-width: 990px)': {
			display: 'block',
		}
	},
	headlinesLoader: {
		flex: 1,
		alignItems: 'center',
		border: '1px solid #E8E8E8',
		padding: '5px 10px',
		marginRight: 30,
		borderRadius: 3,
		'&:last-child': {
			marginRight: 0,
		},
		'@media(max-width: 1300px)': {
			marginRight: 15,
			'&:last-child': {
				marginRight: 0,
			},
		},
		'@media(max-width: 990px)': {
			minHeight: 58,
			margin: '0 0 10px 0',
			'&:last-child': {
				marginBottom: 0,
			},
		}
	},
	graphLoader: {
		height: 375,
		position: 'relative'
	},
	graphLoaderSpinner: {
		position: 'absolute',
		top: 0,
		bottom: 0,
		right: 0,
		left: 0,
		margin: 'auto',
	},

	payment: {
		color: '#A4A4A4',
		fontSize: '1.7rem',
		fontWeight: 400,
		display: 'grid',
		alignItems: 'center',
		justifyContent: 'space-between',
		gridTemplateColumns: '55% 41%',
		gridTemplateRows: 'auto',
		justifyItems: 'stretch',
		gridColumnGap: '1em',
		gridRowGap: '4%',
		'@media(max-width: 1100px)': {
			display: 'block',
		}
	},
	paymentDateInfo: {
		//whiteSpace: 'nowrap',
		'@media(max-width: 1100px)': {
			whiteSpace: 'normal',
			marginBottom: 10
		},
		'@media(max-width: 480px)': {

			lineHeight: '1.45'
		}
	},
	paymentInfo: {
		//whiteSpace: 'nowrap',
		'@media(max-width: 990px)': {
			whiteSpace: 'normal',
			fontSize: '90%',
		}
	},
	paymentDate: {
		color: '#4A4A4A',
		fontWeight: 500,
		marginLeft: '.5rem',
		//whiteSpace: 'nowrap',
		'@media(max-width: 990px)': {
			whiteSpace: 'normal',
		},
		'@media(max-width: 480px)': {
			display: 'block',
			marginLeft: 0,
		}
	},

	paymentOptions: {
		display: 'grid',
		gridTemplateColumns: '15em 6.5em',
		gridTemplateRows: 'auto',
		justifyItems: 'stretch',
		gridColumnGap: '0',
		gridRowGap: '1em',
		marginLeft: 'auto',
		color: '#4a4a4a',
		'@media(max-width: 990px)': {
			gridTemplateColumns: 'auto auto',
			justifyContent: 'flex-start'
		},
		'@media(max-width: 480px)': {
			display: 'block'
		}
	},
	paymentOptionsViewSelector: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-end',
		paddingRight: '1.25rem',
		fontSize: '1.6rem',
		'@media(max-width: 1100px)': {
			justifyContent: 'flex-start',
		},
		'@media(max-width: 480px)': {
			paddingRight: 0,
			marginBottom: 10
		},
		'& > span': {
			fontWeight: 500
		},
		'& .MuiFormControlLabel-root': {
			margin: '0 0 0 10px',
			'& > span': {
				padding: 0,
				marginRight: 5
			}
		}
	},
	paymentOptionsDropDownMenu: {
		borderLeft: '1px solid #ccc',
		paddingLeft: '1.75rem',
		'@media(max-width: 990px)': {
			borderLeft: 'none',
			paddingLeft: 0,
		},
		'& > button': {
			fontSize: '1.8rem',
			padding: '0',
			color: '#4a4a4a',
			height: 'auto',
			lineHeight: '1',
			'& > span': {
				width: 20,
				height: 20,
				display: 'block'
			},
			'& > svg': { // arrow svg
				fontSize: '100%'
			}
		}
	}
});